import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import { FileUpload } from '@mui/icons-material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { ITransitoInventario } from '@/shared/interfaces/erp/administration/transito_inventario.interface';
import { ButtonFileComponente } from '@/shared/components/ui';
import { toast } from 'react-toastify';
import { transitoInventarioArchivoRecepcion, useFetchPutTransitoInventario } from '@/shared/actions/erp/transito_inventaro.actions';
import { useNavigate } from 'react-router-dom';
import { EstadoTransitoInventarioENUM, ROUTER_PATHS } from '@/shared';
import { RECEPCION_DOCUMENTO_ACCEPT, validateRecepcionDocumentoFile } from '../recepcion_documento_upload';

interface DialogRecepcionFirmadaProps {
   dataTransito: ITransitoInventario;
}

export const DialogRecepcionFirmada: React.FC<DialogRecepcionFirmadaProps> = ({ dataTransito }) => {

   const [open, setOpen] = useState(false);

   const navigate = useNavigate();

   const {
      mutateAsync: mutateAsyncPutTransitoInventario
   } = useFetchPutTransitoInventario({
      navigate,
      returnUrl: `${ROUTER_PATHS.inventario.recepcionTransferenciaInventarioNav}`
   })

   const [urlDocumentoRecibido, setUrlDocumentoRecibido] = useState('');
   const handleUploadDocumento = async (
      event: React.ChangeEvent<HTMLInputElement>
   ) => {
      const file = event.target.files?.[0];

      if (!file) return;

      const validationMessage = await validateRecepcionDocumentoFile(file);
      if (validationMessage) {
         toast.error(validationMessage);
         return;
      }

      const formData = new FormData();

      formData.append('archivo', file);
      formData.append('id', dataTransito.id_transito_inventario);

      try {
         const response = await transitoInventarioArchivoRecepcion(formData) as any;
         setUrlDocumentoRecibido(response?.url);
         toast.success(response.message || 'Archivo cargado');

         ///* cambiar solo el estado transito inventario
         mutateAsyncPutTransitoInventario({
            id: dataTransito.id_transito_inventario,
            data: {
               estado_transito: EstadoTransitoInventarioENUM.ENTREGADO,
            }
         })

         setOpen(false)

      } catch (error) {
         console.error(error);
         toast.error('Ocurrio un error al subir el archivo');
      }
   };

   return (
      <>
         <Button
            color="primary"
            endIcon={<FileUpload />}
            onClick={() => {
               setOpen(true)
            }}
         >
            Subir Documento
         </Button>
         {
            open && (
               <ScrollableDialogProps
                  onCloseIcon={() => setOpen(false)}
                  open={open}
                  title="📝 Documento De Recepción Firmada."
                  minWidth="48%"
                  contentNode={
                     <Grid container spacing={3}>
                        <Grid item xs={12}>
                           <Grid item>
                              {urlDocumentoRecibido === '' ? (
                                 <ButtonFileComponente
                                    titulo={'Documento Recepción Firmada'}
                                    accept={RECEPCION_DOCUMENTO_ACCEPT}
                                    onChange={(e) => handleUploadDocumento(e)}
                                 />
                              ) : 'Documento ya cargado'}
                           </Grid>
                        </Grid>
                     </Grid>
                  }
               />
            )
         }
      </>
   );
};
